// extracted by mini-css-extract-plugin
export default {"wrap":"modalAdvert__wrap__yp2DL","shop":"modalAdvert__shop__dYS5J","content":"modalAdvert__content__SkDqh","cornerImg":"modalAdvert__cornerImg__aAKiO"};